<template lang="pug">
</template>
<script>
export default {
  name: "cms-detail",
  data() {
    return {
      prevRoute: null
    }
  },
  computed: {
    route() {
      return this.$route.params
    }
  },
  async activated() {
    const category_ = this.$store.state.data[this.route.target]?.find(category => category.id == this.route.category)
    const content = category_?.items.find(item => item.id == this.route.id)

    await this.$nextTick()
    if (!content) __.platform.go(this.prevRoute.path)

    if (content.content_type === "default" && content.layout_type === "boxed")
      this.$router.push({
        name: "cmsDetailBoxed",
        params: { ...this.$route.params, content, prevRoute: this.prevRoute.path }
      })
    else if (content.content_type === "default" && content.layout_type === "sidepane") __.platform.go(this.prevRoute.path)
    else if (content.content_type === "default")
      this.$router.push({
        name: "cmsDetailDefault",
        params: { ...this.$route.params, content, prevRoute: this.prevRoute.path }
      })
    else if (content.content_type === "image")
      this.$router.push({
        name: "cmsDetailImage",
        params: { ...this.$route.params, content, prevRoute: this.prevRoute.path }
      })
    else if (content.content_type === "video")
      this.$router.push({
        name: "cmsDetailVideo",
        params: { ...this.$route.params, content, prevRoute: this.prevRoute.path }
      })
    else __.platform.go(this.prevRoute.path)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => (vm.prevRoute = from))
  }
}
</script>

<style lang="scss" scoped>
.cdd-bottom {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 180px;

  .cdd-video {
    margin-top: -180px;
    border-width: 4px !important;
    margin: -180px auto 0 auto;
  }
  .cdd-carousel {
    margin-top: -180px;

    .imagec {
      border-width: 4px !important;
      background: transparent !important;
    }
  }
}

.cdd-action {
  margin-top: 20px;
  position: relative;
}

.cdd-content {
  .cdd-content-scroll-container {
    position: absolute;
    top: 20px;
    bottom: 15px;
    left: 0;
    right: 0;
    overflow: auto;
    padding: 0 15px 5px 0;
    line-height: 1.4em;
    text-align: justify;
  }
}

.noImage {
  .cdd-bottom {
    margin-top: 50px;
  }

  .cdd-content {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}
</style>
